import request from '@/utils/request'

let AnalysisApi = {
  /*获取表列表*/
  getTableList(data) {
    return request._get('/shop/plus.data.analysis/getTableList', data);
  },
  /*获取表信息*/
  getTableInfo(data) {
    return request._get('/shop/plus.data.analysis/getTableInfo', data);
  },
    /*数据打标签*/
  syncLabel(data) {
    return request._get('/shop/plus.data.analysis/syncLabel', data);
  },
  /*抓取手机号*/
  syncPhone(data) {
    return request._get('/shop/plus.data.analysis/syncPhone', data);
  },

  /*获取分析结果*/
  getTableResult(data) {
    return request._post('/shop/plus.data.analysis/getTableResult', data);
  },
  /*获取筛选历史*/
  getDataHistory(data) {
    return request._post('/shop/plus.data.analysis/getDataHistory', data);
  },
 /*自动打分接口*/
 systemScoring(data) {
  return request._post('/shop/plus.data.analysis/systemScoring', data);
},

 /*重新打分接口*/
 systemReScoring(data,cancel) {
  return request._post('/shop/plus.data.analysis/systemReScoring', data,cancel);
},
 /*批量导出数据-获取*/
 analysysExportData(data) {
  return request._post('/shop/plus.data.analysis/analysysExportData', data);
},
/*批量导出数据-执行导出*/
exportData(data) {
  return request._post('/shop/plus.data.analysis/exportData', data);
},
 /*人工打分*/
 artificialScoring(data) {
  return request._get('/shop/plus.data.analysis/artificialScoring', data);
},

 /*删除数据*/
 delData(data,cancel) {
  return request._post('/shop/plus.data.analysis/delData', data,cancel);
},
// 更新官网数据
updContent(data,cancel) {
  return request._post('/shop/plus.data.analysis/updContent', data,cancel);
},
// 发送短信
sendSms(data,cancel) {
  return request._post('/shop/plus.data.analysis/sendSms', data,cancel);
},


 /*获取设置*/
 getSetting(data) {
  return request._get('/shop/plus.data.analysis/setting', data);
},
/*保存设置*/
saveSetting(data) {
  return request._post('/shop/plus.data.analysis/setting', data);
},
}
export default AnalysisApi;



// WEBPACK FOOTER //
// ./src/api/analysis.js